import { IModel, Model } from "../Model";
import { AuthOperationModel, IAuthOperationModel } from "./AuthOperationModel";

export interface IAuthRoleModel extends IModel {
    authRoleId: number
    description: string
    systemId: string | null
    authApplicationId: number
    operations: IAuthOperationModel[] | null
    roleAuthOperationName: string;
}

export class AuthRoleModel extends Model implements IAuthRoleModel {
    authRoleId: number;
    description: string;
    systemId: string | null;
    authApplicationId: number;
    operations: IAuthOperationModel[] | null;
    roleAuthOperationName: string;

    constructor(params: Partial<IAuthRoleModel>) {
        super(params);
        const {
            authRoleId = 0,
            description = '',
            systemId = null,
            authApplicationId = 0,
            operations = null,
            roleAuthOperationName = 'missing'
        } = params;

        this.authRoleId = authRoleId;
        this.description = description;
        this.systemId = systemId;
        this.authApplicationId = authApplicationId;
        this.roleAuthOperationName = roleAuthOperationName;


        this.operations = new Array<IAuthOperationModel>();
        if (operations && operations.length) {
            operations.forEach(value => {
                this.operations!.push(new AuthOperationModel(value));
            });
        }
    }

}
